/* 
Author:Lamiaa Moustafa
Desc: Forms style
*/
import styled from "styled-components";

// contact form style
export const ContactForm = styled.form`
  width: 60%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  font-family: var(--fontFamily);
  padding: 70px 50px;
  p:first-child {
    color: var(--orange);
    font-size: 36px;
    font-weight: var(--boldFont);
    margin-bottom: 0;
  }
  p:nth-child(2) {
    color: var(--black);
    font-size: 18px;
    font-weight: var(--regularFont);
    margin-top: 0;
  }
  input {
    width: 60%;
    margin: 5px 40px;
    border: 1px solid var(--orange);
  }
  label {
    font-family: var(--fontFamily);
    font-weight: 500;
    color: var(--black);
    font-size: 18px;
    margin: 10px 40px 0;
  }

  @media (max-width: 768px) {
    width: 100%;
    padding: 50px 10px;
    input {
      width: 80%;
    }
    textarea {
      width: 80%;
    }
  }
  @media (min-width: 1400px) {
    padding: 150px 70px;
  }
`;

//Form Container for register, My account and access page style
export const FormContainer = styled.section`
  width: 90%;
  /* min-height: 700px;
  overflow: hidden; */
  /* overflow-y: scroll;
  color: var(--orange);
  scrollbar-width: thin; */
  padding: 2em 1em;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  //background-color: var(--white);
  background-color: rgba(254, 254, 254, 0.6);
  /* opacity: 0.7; */
  /* overflow-y: scroll;
  ::-webkit-scrollbar {
    width: 1em;
  }
  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  }
  ::-webkit-scrollbar-thumb {
    background-color: var(--darkGray);
    outline: 1px solid var(orange);
  } */

  div {
    align-items: center;
  }
  input {
    border: 2px solid var(--orange);
  }
  label {
    font-size: 18px;
    font-weight: var(--boldFont);
    color: var(--grayBlack);
  }
  @media (max-width: 768px) {
    /* width: 90%; */
    height: auto;
    overflow: auto;
    position: relative;
  }
  @media (min-width: 1400px) {
    width: 80%;
  }
`;
